import { render, staticRenderFns } from "./GymRouteAvatar.vue?vue&type=template&id=5a8c3751"
import script from "./GymRouteAvatar.vue?vue&type=script&lang=js"
export * from "./GymRouteAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports